import { MapOutputWithStatus } from './map-output-with-status.model';


export class MapSelectByIdOutput implements IMapSelectByIdOutput {
    status!: number;
    message!: string;
    data!: MapOutputWithStatus;

    constructor(data?: IMapSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? MapOutputWithStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MapSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new MapSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IMapSelectByIdOutput {
    status: number;
    message: string;
    data: MapOutputWithStatus;
}

